module.exports = __webpack_public_path__ + "static/media/80Mbps.116976b6.bin";